import React, { useEffect } from "react";
import { LEVEL_UP_BG, RANK_UP_BG } from "../lib/gameLogic";
import { Sparkles, ChevronsUp, Crown } from "lucide-react";

export default function LevelUpModal({ event, onClose }) {
  useEffect(() => {
    if (!event) return;
    const t = setTimeout(onClose, event.rankedUp ? 5200 : 4000);
    return () => clearTimeout(t);
  }, [event, onClose]);

  if (!event) return null;

  const isRankUp = event.rankedUp;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-md"
      onClick={onClose}
      data-testid="level-up-modal"
    >
      <div
        className="absolute inset-0 opacity-60"
        style={{
          backgroundImage: `url(${isRankUp ? RANK_UP_BG : LEVEL_UP_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-transparent to-black/80" />

      {/* Particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {Array.from({ length: 24 }).map((_, i) => (
          <span
            key={i}
            className="absolute block w-1 h-1 bg-white rounded-full opacity-70"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `rise ${1.4 + Math.random()}s ease-out ${
                Math.random() * 0.8
              }s both`,
              boxShadow: "0 0 8px rgba(139,92,246,0.9)",
            }}
          />
        ))}
      </div>

      <div className="relative text-center px-6 animate-burst">
        <div className="flex items-center justify-center gap-2 text-xs uppercase tracking-[0.4em] text-blue-300 mb-3">
          <Sparkles className="h-3 w-3" />
          The System
          <Sparkles className="h-3 w-3" />
        </div>
        {isRankUp ? (
          <>
            <Crown
              className="mx-auto h-14 w-14 mb-2"
              style={{ color: event.newRank.color }}
            />
            <div className="font-display font-black uppercase text-5xl md:text-7xl lg:text-8xl text-white tracking-tighter text-glow-purple">
              Rank Up
            </div>
            <div
              className="mt-4 font-mono text-2xl md:text-4xl uppercase tracking-[0.3em]"
              style={{ color: event.newRank.color }}
            >
              {event.oldRank.code} → {event.newRank.code}-RANK
            </div>
            <div className="mt-3 text-slate-300 max-w-lg mx-auto">
              You have ascended, Hunter. The shadows recognize your power as a{" "}
              <span style={{ color: event.newRank.color }}>
                {event.newRank.name}
              </span>
              .
            </div>
          </>
        ) : (
          <>
            <ChevronsUp className="mx-auto h-12 w-12 text-purple-300 mb-2 text-glow-purple" />
            <div className="font-display font-black uppercase text-5xl md:text-7xl lg:text-8xl text-white tracking-tighter text-glow-blue">
              Level Up
            </div>
            <div className="mt-4 font-mono text-2xl md:text-3xl tracking-[0.3em] text-blue-300">
              LV {event.oldLevel} → LV {event.newLevel}
            </div>
            <div className="mt-3 text-slate-300">
              You have levelled up, Hunter. The System acknowledges your effort.
            </div>
          </>
        )}
        <div className="mt-6 font-mono text-xs text-slate-400 uppercase tracking-[0.3em]">
          + {event.gain} XP gained · Tap to dismiss
        </div>
      </div>
    </div>
  );
}
